export const START_PAGE_PREFERENCE = 'preferredStartPage';
export const DATE_FORMAT_PREFERENCE = 'preferredDateFormat';
export const TIME_FORMAT_PREFERENCE = 'preferredTimeFormat';
export const APP_NOTIFICATION_PREFERENCE = 'appNotifications';
export const EMAIL_NOTIFICATION_PREFERENCE = 'emailNotifications';
